import React, { useState } from 'react';
import { useApp } from '../../context/AppContext';

const DAYS = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
const PERIODS = [1,2,3,4,5,6,7,8];
const PERIOD_TIMES = { 1:'09:00-09:45', 2:'09:45-10:30', 3:'10:45-11:30', 4:'11:30-12:15', 5:'13:00-13:45', 6:'13:45-14:30', 7:'14:30-15:15', 8:'15:15-16:00' };
const SUBJECT_COLORS = ['bg-blue-100 text-blue-700','bg-green-100 text-green-700','bg-purple-100 text-purple-700','bg-yellow-100 text-yellow-700','bg-pink-100 text-pink-700','bg-indigo-100 text-indigo-700','bg-orange-100 text-orange-700','bg-teal-100 text-teal-700','bg-red-100 text-red-700','bg-cyan-100 text-cyan-700'];

function Timetable() {
  const { timetable, classes, subjects, staff } = useApp();
  const [selectedClass, setSelectedClass] = useState(classes[0]?.id || '');

  const subjectColorMap = subjects.reduce((acc,s,i)=>({...acc,[s.id]:SUBJECT_COLORS[i%SUBJECT_COLORS.length]}),{});

  const getSlot = (day, period) => timetable.find(t=>t.classId===selectedClass && t.day===day && t.period===period);
  const getSubjectName = (id) => subjects.find(s=>s.id===id)?.name || '-';
  const getTeacherName = (id) => { const s=staff.find(s=>s.id===id); return s?`${s.firstName} ${s.lastName}`.split(' ').map(n=>n[0]).join('')+'.'+s.lastName:'-'; };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="text-2xl font-bold">Timetable</h1><p className="text-gray-500 text-sm">Weekly class schedule</p></div>
        <select value={selectedClass} onChange={e=>setSelectedClass(e.target.value)}
          className="px-3 py-1 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-300">
          {classes.map(c=><option key={c.id} value={c.id}>{c.name} - Sec {c.section}</option>)}
        </select>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-50 border-b border-gray-100">
              <th className="px-3 py-3 text-left font-semibold w-24">Period</th>
              {DAYS.map(d=><th key={d} className="px-3 py-3 text-center font-semibold">{d}</th>)}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-50">
            {PERIODS.map(p=>(
              <tr key={p} className="hover:bg-gray-50">
                <td className="px-3 py-1">
                  <div className="font-semibold">P{p}</div>
                  <div className="">{PERIOD_TIMES[p]}</div>
                </td>
                {DAYS.map(d=>{
                  const slot = getSlot(d,p);
                  return (
                    <td key={d} className="px-2 py-2 text-center">
                      {slot ? (
                        <div className={`${subjectColorMap[slot.subjectId]||'bg-gray-100'} rounded-lg px-2 py-1.5`}>
                          <div className="font-semibold">{getSubjectName(slot.subjectId)}</div>
                          <div className="opacity-70">{getTeacherName(slot.teacherId)}</div>
                        </div>
                      ) : <span className="text-gray-200">—</span>}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
export default Timetable;
